<template>
  <!-- 登录 -->
  <div class="sign-box sign-in">
    <div class="rounded box-shadow bg-white p-4 w-100 translate">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="h4 font-weight-bold">Sign in</h4>
        <a href="#login-box" data-login="close">
          <i class="icon-style icon-xs style-close"></i>
        </a>
      </div>
      <div class="pt-4">
        <my-input v-model="email" type="email" placeholder="Email"></my-input>
        <my-input
          v-model="password"
          type="password"
          placeholder="Password"
          :err-msg="errMsg"
        ></my-input>
        <div class="form-group d-flex justify-content-between">
          <div class="form-check">
            <!--<input-->
            <!--class="form-check-input is-invalid"-->
            <!--type="checkbox"-->
            <!--id="gridCheck"-->
            <!--/>-->
            <!--<label class="form-check-label" for="gridCheck">-->
            <!--Keep signed in-->
            <!--</label>-->
          </div>
          <a href="#login-box" data-login=".sign-forgot" class="small"
            >Forgot password?</a
          >
        </div>
        <div class="py-2">
          <button
            type="button"
            class="btn btn-primary d-block w-100"
            @click="signIn()"
          >
            Sign in
          </button>
        </div>
        <div class="py-2">
          <a
            href="#login-box"
            data-login=".sign-up"
            class="btn btn-outline-secondary d-block"
            >Sign up now</a
          >
        </div>
        <!--<div class="pt-4 text-center">-->
        <!--<div class="small">Other login</div>-->
        <!--<div>-->
        <!--<a href="#" class="d-inline-block m-2">-->
        <!--<i class="icon-img icon-xxxs img-facebook"></i>-->
        <!--</a>-->
        <!--<a href="#" class="d-inline-block m-2">-->
        <!--<i class="icon-img icon-xxxs img-twitter"></i>-->
        <!--</a>-->
        <!--<a href="#" class="d-inline-block m-2">-->
        <!--<i class="icon-img icon-xxxs img-google"></i>-->
        <!--</a>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../../utils/Request";
import MyInput from "../../form/MyInput";
import MyLocalStorage from "../../../utils/MyLocalStorage";
import md5 from "js-md5";
import Validators from "../../../utils/Validators";

export default {
  name: "SignIn",
  components: { MyInput },
  data() {
    return {
      email: "",
      password: "",
      errMsg: "",
      isLoading: false,
      rememberLogin: false
    };
  },
  methods: {
    signIn() {
      this.errMsg = "";
      if (!this.email || !this.password) {
        this.errMsg = "Email and password cannot be empty.";
        return;
      }
      if (!Validators.email(this.email)) {
        this.errMsg = "Incorrect email format.";
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      request({
        baseURL: process.env.VUE_APP_USER_API_URL,
        url: "/v2/auth/token",
        data: {
          grant_type: "password",
          username: this.email,
          password: md5(this.password)
        }
      })
        .then(response => {
          if (response.code !== 200) {
            this.errMsg = response.msg;
          } else {
            MyLocalStorage.setAccessToken(response.data.access_token);
            this.$store.commit("set_user", { username: this.email });
            this.$store.dispatch("GetInfo");
            $("#login-box").removeClass("show");

            this.email = "";
            this.password = "";
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped></style>
